<template>
  <div class="header-wrapper animate fadeIn">
    <div class="container">
      <div class="row">
        <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <form class="block-border radius block shadow form--box" @submit.prevent="submit" novalidate>
            <h3 class="mb-15">ลืมรหัสผ่าน (เฉพาะสมัครสมาชิกด้วยอีเมลเท่านั้น)</h3>
            <div class="alert alert--info">ผู้ที่สมัครสมาชิกด้วยเบอร์โทรศัพท์กรุณาติดต่อได้ที่<br />อีเมล <a href="mailto:tcfe@ktf.premier.co.th">tcfe@ktf.premier.co.th</a><br />เบอร์โทรศัพท์ 02-301-1117</div>
            <div class="">
              <label class="form__label" for="email">อีเมล</label>
              <input class="form__text" type="email" id="email" v-model="email" required :class="{ 'form__input--error': $v.isError('email') }" />
              <div class="alert alert--error" v-show="$v.$errors.email.empty">กรุณากรอกอีเมล</div>
              <div class="alert alert--error" v-show="$v.$errors.email.invalid">กรุณากรอกอีเมลให้ถูกต้อง</div>
            </div>
            <button class="btn btn--purple btn--full" :disabled="submitting">ส่งข้อมูล</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'user_forgot',
  data () {
    return {
      submitting: false,
      email: '',
      $v: null
    }
  },
  created () {
    this.$store.dispatch('initUser').then(() => {
      if (this.$store.state.user) {
        this.$router.push('/')
      }
    })

    this.$v = this.$validator.init(this, {
      email: { checkEmpty: true, checkEmail: true }
    })
  },
  methods: {
    submit (event) {
      if (!this.$v.validate()) {
        this.$forceUpdate()
        this.$utils.scrollToFirstErrors()
        return
      }

      if (this.submitting) {
        return
      }
      this.submitting = true

      this.$modal.show({
        title: 'กำลังส่งข้อมูล',
        text: 'กรุณารอสักครู่',
        okButton: false
      })

      this.$http.post('members/forget', { email: this.email })
        .then(resp => {
          this.submitting = false
          this.$modal.show({
            title: 'ระบบได้ส่งข้อมูลการรีเซ็ตรหัสไปที่อีเมลของคุณแล้ว',
            text: 'กรุณาตรวจสอบอีเมลของคุณ และทำตามคำแนะนำในอีเมล',
            ok: () => {
              this.$router.push('/user/login')
            }
          })
        })
        .catch(err => {
          console.log(err)
          this.submitting = false
          this.$utils.showCommonError()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .header-wrapper {
    .container {
      background: transparent;
    }
  }
  .notice {
    padding: 7px 0;
  }
</style>



// WEBPACK FOOTER //
// ForgotPassword.vue?df25b4f2